export default {
  'user.login': 'تسجيل الدخول',
  'user.signup': 'الاشتراك',
  'user.profile': 'الملف الشخصي',
  'user.reset_password': 'إعادة تعيين كلمة المرور',
  'user.user_management': 'إدارة المستخدمين',
  'user.send_verification_sms': 'إرسال رسالة تحقق SMS',
  'user.verification_check': 'فحص التحقق',
  'user.change_password': 'تغيير كلمة المرور',
  'user.username_email': 'اسم المستخدم / البريد الإلكتروني',
  'user.email': 'البريد الإلكتروني',
  'user.phone': 'الهاتف المحمول بدون صفر',
  'user.password': 'كلمة المرور',
  'user.forgetpassword': 'نسيت كلمة المرور؟',
  'user.loginwithgoogle': 'تسجيل الدخول باستخدام Google',
  'user.createaccount': 'إنشاء حساب',
  'user.offerservices': 'نحن نقدم جميع خدمات السفر',
  'user.welcome': 'مرحبًا بك في تريبسي',
  'user.justwelcome': 'تسجيل الدخول',
  'user.rememberme': 'تذكرني',
  'user.donthaveaccount': 'لم تقم بالتسجيل من قبل؟',
  'user.clickhere': 'انقر هنا',
  'user.firstname': 'الاسم الأول',
  'user.lastname': 'الاسم الأخير',
  'user.agreemessage': 'أوافق على',
  'user.rotapolicy': 'أوافق على قواعد Tripsi',
  'user.rotapolicy_tripord': 'أوافق على قواعد Tripord',
  'user.rotacopyright': 'حقوق النشر © 2018 Tripsi',
  'user.emptypass': 'يرجى إدخال كلمة مرور قديمة أو جديدة',
  'user.oldpass': 'كلمة المرور القديمة غير مطابقة!',
  'user.employeeadd': 'تمت إضافة الموظف بنجاح!',
  'user.changepass': 'تم تغيير كلمة المرور بنجاح!',
  'user.tryagain': 'الرجاء المحاولة مرة أخرى',
  'user.changepasssuccess': 'لم يتم تغيير كلمة المرور الخاصة بك',
  'user.newpass': 'الرجاء إدخال كلمة مرور جديدة',
  'user.loginerror': 'اسم المستخدم أو كلمة المرور غير صحيحة',
  'user.userlock': 'اسم المستخدم مقفل',
  'user.changepasserror':
    'كلمة المرور الجديدة وإعادة إدخال كلمة المرور الجديدة غير متطابقتين',
  'user.tripsi': 'تريبسي',
  'user.tripord': 'تريب ارد',
  'user.userpoint': 'نقاط المستخدم',
  'user.duplicatedusername': 'البريد الإلكتروني مكرر',
  'user.signuperror': 'يجب أن يكون البريد الإلكتروني فريدًا',
  'user.avatar': 'الصورة الرمزية',
  'user.forgetyour': 'نسيت',
  'user.createyour': 'إنشاء حسابك',
  'user.account': 'حساب',
  'user.registerwith': 'أو سجل باستخدام',
  'user.acceptrules': 'يرجى قبول قواعد الموقع',
  'user.fillallfield': 'يرجى ملء جميع الحقول',
  'user.favourites': 'المفضلة',
  'user.nograde': 'بدون درجة',
  'user.phone': 'رقم الهاتف',
  'user.has_account': 'لدي حساب على Tripsi',
  'user.has_account_tripord': 'لدي حساب على Tripord',
  'user.signup_free': 'الاشتراك مجاني',
  'user.pass_recovery': 'استعادة كلمة المرور',
  'user.remember_password': 'هل تتذكر كلمة المرور؟',
  'authentication.slugone': 'أكثر مورد موثوق للخدمات السياحية في إيران',
  'user.otplogin': 'تسجيل الدخول بإرسال رمز عبر SMS',
  'user.otplogintitle': 'كلمة مرور لمرة واحدة',
  'user.incorrectcode': 'الرمز المدخل غير صحيح',
  'user.untilresend': 'حتى إعادة الإرسال',
  'user.phoneoremail': 'البريد الإلكتروني أو الهاتف المحمول',
  'user.loginwithusername': 'تسجيل الدخول باستخدام اسم المستخدم',
  'user.sendcode': 'إرسال الرمز',
  'user.sendagain': 'إعادة الإرسال',
};
